 
<template>
  <div>
    <div class="group_3 flex-col"></div>
    <span class="text_17">绑定微信</span>

    <span class="text_18">绑定微信后，可通过微信扫码登录，无需输入账号和密码</span>
    <span class="text_19">绑定后可随时在电脑端解绑</span>
    <span class="text_20">微信扫码下方二维码即可完成绑定</span>
    <div class="group_4">
      <!-- <div id="wxLogin"></div> -->
      <iframe name="wxIframeQr"
        src='https://open.weixin.qq.com/connect/qrconnect?appid=wx13fce24cf56abac9&self_redirect=true&scope=snsapi_login&href=https://www.lvluoxinli.com/wechat-qr.css&redirect_uri=https://mp.api.lvluoxinli.com/api/user/oplatform/report?cb=https://www.lvluoxinli.com/qr.html'
        frameborder="0" scrolling="no" height="329px" width="300px"> </iframe>
    </div>
  </div>
</template>
<script>
import {  mapState,mapActions } from 'vuex'
export default {
  name: "WecahtQr",
  computed: {
    ...mapState([
      'teacherAdmin'
    ])
  },
  methods: {

    ...mapActions([
      'getUpdateTeacherInfo'
    ]),
  },
    mounted () {
      //   'teacherAdmin'

      // window.addEventListener('message',  async (event) => {
      //   //  微信lang绑定
      //   let openids=JSON.parse(sessionStorage.getItem('wxuserInfo'))
      //   let result = {
      //     uid: this.teacherAdmin.uid,
      //     LANG:openids.unionid,
      //     school_id: 1,
      //   }
      //   await this.getUpdateTeacherInfo(result)
      //   console.log(event)
      // })
    }
  }

</script>
<style scoped>

.group_3 {
  background-color: rgba(232, 232, 232, 1);
  width: 600px;
  height: 1px;
  margin-top: 16px;
}

.text_17 {
  width: 160px;
  height: 40px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 40px;
  font-family: SourceHanSansCN-Bold;
  font-weight: 700;
  text-align: justify;
  white-space: nowrap;
  line-height: 40px;
  margin: 32px 0 0 40px;
  display: flex
}

.text_18 {
  width: 450px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(23, 26, 29, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: right;
  white-space: nowrap;
  line-height: 18px;
  margin: 16px 0 0 40px;
  display: flex
}

.text_19 {
  width: 216px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(23, 26, 29, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: right;
  white-space: nowrap;
  line-height: 18px;
  margin: 8px 46px 0 40px;
  display: flex
}

.text_20 {
  display: flex;
  width: 270px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(23, 26, 29, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: right;
  white-space: nowrap;
  line-height: 27px;
  margin: 25px 0 0 40px;
}



.group_4 {
  display: flex;
  flex-direction: row;
  justify-content: center; /* 相对父元素水平居中 */
  /* background-color: rgba(216, 216, 216, 1); */
  /* width: 200px;
  height: 200px; */
   margin: 47px ;
}

</style>